// extracted by mini-css-extract-plugin
module.exports = {"nbFooter":"footer-module--nb-footer--w2RSZ","footerInfoSingle":"footer-module--footer-info-single--1l7X7","title":"footer-module--title--xqtcx"};